import '../style/index.less';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { ThemeProvider } from '@mui/material';
import { AppStore } from './store';
import { theme } from '../style/theme';
import { AuthComponent } from './components';
import './i18n'; //for localization
import { createRoot } from 'react-dom/client';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { Buffer } from 'buffer';
const container = document.getElementById('root')!;
const root = createRoot(container);
const cacheValue = createCache({
  key: 'nonce',
  nonce: Buffer.from('secretnoncephilips', 'base64').toString('base64'),
});
root.render(
  <CacheProvider value={cacheValue}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Provider store={AppStore}>
          <AuthComponent />
        </Provider>
      </ThemeProvider>
    </BrowserRouter>
  </CacheProvider>
);
